// The rail's identity card for the unscheduled-visit flow's desktop screens
// (KAN-771): Log Job's OWN card (heading, name, address, "Logged by" row) drawn
// from data the flow already holds, so the top of the right column is the same
// card, at the same height, on the Reason step, in Log Job's route fallback and
// in its first skeleton frame. The "Logged by" row is reserved at Log Job's
// height (`reservePills`) and shows the signed-in user — what Log Job's own row
// resolves to unless the customer has a distinct assigned worker (then Log Job
// swaps the row's content inside the same box). `onChange` adds the quiet
// "Change" link in the card's top-right (Reason step only).
import { useIntl } from 'react-intl';
import { useAuth } from '../../../AuthContext';
import { foundation } from '../../../ui/tokens';
import LogJobIdentityCard from '../../../pages/LogJobIdentityCard';
import LogJobHeroContextPills from '../../common/LogJobHeroContextPills';
import { wizardChangeLinkStyle } from '../../common/wizard/wizardChromeStyles';

const noop = () => {};

/**
 * @param {object} props
 * @param {string} props.name
 * @param {string} [props.address]
 * @param {boolean} [props.offSeason] - customer's pool is closed (Log Job's heading + pill).
 * @param {object|null} [props.customer] - the picked customer row, when known.
 * @param {() => void} [props.onChange]
 * @param {string} [props.testId]
 */
export default function UnscheduledRailIdentity({ name, address, offSeason = false, customer = null, onChange, testId = 'unscheduled-rail-identity' }) {
  const intl = useIntl();
  const { sessionUser, sessionFullName, role } = useAuth();
  const loggedByName = sessionFullName || sessionUser?.user_metadata?.full_name || null;
  return (
    <LogJobIdentityCard
      // KAN-1085: plain heading; the off-season pill carries the season.
      heading={intl.formatMessage({ id: 'logJob.title', defaultMessage: 'Log Job' })}
      name={name}
      address={address}
      // Only office roles can get the attribution picker (KAN-1064), so only they reserve its row.
      reservePills={role === 'admin' || role === 'supervisor'}
      pills={(
        <LogJobHeroContextPills
          loggedByName={loggedByName}
          isFollowUp={false}
          isOffSeason={offSeason}
          role={role}
          sessionUser={sessionUser}
          customer={customer}
          selectedRouteWorkerId={null}
          setSelectedRouteWorkerId={noop}
          attributionLoading={false}
          isPoolIndustry={false}
        />
      )}
      testId={testId}
      action={onChange ? (
        <button
          type="button"
          style={{ ...wizardChangeLinkStyle, alignSelf: 'flex-start', margin: `-${foundation.spacePx[2]} -${foundation.spacePx[1]} 0 0` }}
          onClick={onChange}
          data-testid={`${testId}-change`}
        >
          {intl.formatMessage({ id: 'wizard.identityStrip.change', defaultMessage: 'Change' })}
        </button>
      ) : null}
    />
  );
}
